import { t, type TranslatedString } from "@i18n";
import {
  resolveErrorContentWith,
  resolveThrownErrorContentWith,
  type ApiErrorBody,
  type ErrorContentTranslate,
} from "@Helpers/errorContent";

export type { ApiErrorBody };

/**
 * Web's `t`, bound to the signature `packages/helpers` resolves through. The helper's key type is
 * `CatalogKey` (`keyof` en.json), the same union as `TranslationKey`, so the mapper's sentences reach
 * the typed `t()` without a cast.
 *
 * This adapter is the ONLY thing web still owns here — the resolution and the `TranslatedString`
 * brand live in `@Helpers/errorContent`, shared with mobile.
 */
const translate: ErrorContentTranslate = (key, options) => t(key, options);

/** Turns a failure body into the text to show the user. */
export function resolveErrorContent(body: ApiErrorBody | null | undefined): TranslatedString {
  return resolveErrorContentWith(translate, body);
}

/**
 * `resolveErrorContent` for an axios rejection, where the body sits under `error.response.data` and
 * the whole thing is `unknown` until proven otherwise.
 */
export function resolveThrownErrorContent(error: unknown): TranslatedString {
  return resolveThrownErrorContentWith(translate, error);
}
